"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ShopPageSubscriptionDisplay = ShopPageSubscriptionDisplay;
const react_i18next_1 = require("react-i18next");
const date_fns_1 = require("date-fns");
const shop_page_subscription_entries_1 = require("./shop-page-subscription-entries");
const react_1 = __importDefault(require("react"));
const site_1 = require("../../shared/contexts/site");
const types_1 = require("../../shared/types");
const ShopPageSubscriptionsDisplayProvider_1 = require("../provider/ShopPageSubscriptionsDisplayProvider");
const window_1 = require("../../shared/contexts/window");
const doterraTooltip_1 = __importDefault(require("../../shared/components/doterraTooltip"));
function ShopPageSubscriptionDisplay({ subscription, loyaltyCount }) {
    const { t } = (0, react_i18next_1.useTranslation)();
    const { contextPath } = (0, site_1.useSiteState)();
    const { orderContext, subscriptionContext } = (0, ShopPageSubscriptionsDisplayProvider_1.useSubscriptionOverviewState)();
    const { lrpTemplateCode, lrpSubType } = subscriptionContext || {};
    const manageURL = `${contextPath}/subscriptions/edit-subscription/${subscription.code}/${subscription.childLrpTemplate.code}`;
    const { isMobile } = (0, window_1.useWindow)();
    const isDisable = orderContext && lrpTemplateCode !== subscription.childLrpTemplate.code && lrpSubType !== types_1.LrpSubType.INSTANT;
    const handleButtonClick = (e) => {
        if (isDisable) {
            e.preventDefault();
            return;
        }
        window.location.href = manageURL;
    };
    return react_1.default.createElement("div", { className: "loyalties__new-orders-box-results subscription_loyalty_result_add" },
        react_1.default.createElement("div", { className: "loyalties__orders-box-results-head" },
            react_1.default.createElement("div", null,
                react_1.default.createElement("div", { className: "loyalties__orders-box-date-label subscription_home_page_name" }, subscription.subscriptionName),
                react_1.default.createElement("div", { className: "loyalties__orders-box-date-data subscription_home_page_date" }, (0, date_fns_1.format)(subscription.childLrpTemplate.lrpNextActivationDate, 'dd MMMM yyyy'))),
            react_1.default.createElement("div", { className: "loyalties__orders-box-results-head-change-date" },
                react_1.default.createElement("button", { className: `btn btn-size-sm w-auto btn-primary`, "data-lrp-date": subscription.childLrpTemplate.lrpNextActivationDate, disabled: isDisable, onClick: handleButtonClick, "data-tooltip-html": t("text.multiMonth.manage.disabled"), "data-tooltip-id": "tooltipIdManage" }, t("text.multiMonth.manage")),
                orderContext && lrpTemplateCode !== subscription.childLrpTemplate.code && lrpSubType !== types_1.LrpSubType.INSTANT
                    &&
                        react_1.default.createElement(doterraTooltip_1.default, { id: "tooltipIdManage", variant: "light", place: isMobile ? 'top-start' : 'left' }))),
        react_1.default.createElement(shop_page_subscription_entries_1.ShopPageSubscriptionEntries, { loyaltyOrder: subscription.childLrpTemplate, loyaltyCount: loyaltyCount }));
}
